import { useEffect, useState } from 'react';
import api, {
  currentUserUrl
} from 'helpers/api';
import { Map } from 'immutable';

import { useSelector } from 'react-redux';


export function useOrganizationUsersSubscriptions(organizationId, questionBankId, users = new Map()) {
  const session = useSelector(state => state.session);
  const [usersSubscriptions, setUsersSubscriptions] = useState({});

  useEffect(() => {
    if (!organizationId || !questionBankId) return;

    const userIds = Object.keys(users.toJS());

    const fetchSubscriptions = async () => {
      const data = await api.get(`${currentUserUrl({ session })}/organizations/${organizationId}/users_subscriptions`,
        { params: { user_ids: userIds.toString(), question_bank_id: questionBankId } });
      setUsersSubscriptions(prev => ({ ...prev, ...data }));
    };

    fetchSubscriptions();
  }, [users]);

  return usersSubscriptions;
}
